import { forwardRef } from 'react';

export const EuroHouseIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg width="130" height="100" viewBox="0 0 130 100" fill="none" ref={ref} {...props}>
        <path
          d="m51.964 24.793-5.114-3.794-33.98 25.138v51.34h67.96v-19.66"
          stroke="currentColor"
          strokeWidth="1.243"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M56.136 97.492V68.445a1.397 1.397 0 0 0-.352-.997 1.376 1.376 0 0 0-.946-.459h-15.44a1.354 1.354 0 0 0-.941.46 1.377 1.377 0 0 0-.342.996v29.047h18.021ZM3.112 53.333l21.87-16.159L46.85 20.999l5.114 3.794"
          stroke="currentColor"
          strokeWidth="1.243"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M91.14 72.861c19.25 0 34.856-15.721 34.856-35.115 0-19.393-15.606-35.115-34.857-35.115-19.25 0-34.856 15.722-34.856 35.115 0 19.394 15.605 35.115 34.856 35.115Z"
          stroke="currentColor"
          strokeWidth="1.243"
        />
        <path
          d="M99.484 25.741a11.024 11.024 0 0 0-4.004-2.867 10.951 10.951 0 0 0-4.844-.829c-3.247 0-10.877 2.404-10.877 15.93 0 10.811 5.439 15.472 10.877 15.472 5.44 0 7.647-1.635 8.849-2.878M75.797 35.358h17.177M75.797 41.737h14.011"
          stroke="currentColor"
          strokeWidth="1.243"
          strokeLinecap="round"
        />
      </svg>
    );
  },
);
